import RatingItem from "../../GlobalClassification/RatingItem";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function AdvancesearchRating() {
  const { searchObject, setSearchObject, t } = useAdvanceSearchContext();

  function onChangeRanting(rating) {
    setSearchObject({ ...searchObject, rating: rating });
  }
  
  return (
    <>
      <fieldset>
        <legend>{t("Rating(min.)")}</legend>
        <div>
          <RatingItem skill={searchObject} onChange={onChangeRanting} />
        </div>
      </fieldset>
    </>
  );
}
